import { convertArrayOfPrimitiveToHashTable } from '@/utils/arrayToHashTable';
import mailNotificationTypes from '../constants/mailNotificationTypes';

/**
 * @param {object} input
 * @param {boolean} input.monthlyNotification
 * @param {string[]} input.financialNotifications
 * @param {string[]} input.campaignRelatedNotifications
 *
 * @return {object} result
 * @return {boolean} result.lowBudgetAlerts
 * @return {boolean} result.newsletter
 * @return {boolean} result.dailyStats
 * @return {boolean} result.keywordsAlerts
 * @return {boolean} result.campaignsStopAlerts
 */

export default function transformNotificationTypes({
  monthlyNotification,
  financialNotifications,
  campaignRelatedNotifications,
}) {
  const objectOfFinancialNotifications = convertArrayOfPrimitiveToHashTable(
    financialNotifications,
  );
  const objectOfCampaignRelatedNotifications = convertArrayOfPrimitiveToHashTable(
    campaignRelatedNotifications,
  );

  const defaultResult = {};
  Object.values(mailNotificationTypes).forEach(notifType => {
    defaultResult[notifType] = false;
  });

  return {
    ...defaultResult,
    [mailNotificationTypes.NEWSLETTER]: monthlyNotification,
    ...objectOfFinancialNotifications,
    ...objectOfCampaignRelatedNotifications,
  };
}
